import FileInputZone from './file-input';

export { FileInputZone };
